import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-color-picker',
  templateUrl: './color-picker.component.html',
  styles: ``
})
export class ColorPickerComponent {
  @Output() selectedColor = new EventEmitter();
  @Input() defualtColor = '';
  changedColor: any
  reg = /^#([0-9a-f]{3}){1,2}$/i
  ngOnInit(): void {
    // this.selectedColor.emit(this.defualtColor);
  }

  handleChangeComplete(color: any) {
    this.changedColor = color;
    this.selectedColor.emit(color)

  }

  OnWriteColor(text: string) {
    let color = text
    if (text[0] != '#') {
      color = `#${color}`
    }
    if (this.reg.test(color)) {
      this.handleChangeComplete(color);
    }

  }
}
